import { Action, Dispatch, bindActionCreators } from 'redux';
import { FeeScheduleComponent, StateProps, DispatchProps } from '../components/fee-schedule/FeeSchedule';
import { onPageDidMount, onPageWillUnmount } from '../redux/core';
import { saveFeeSchedule, setBillingProviderId, setCptSearch, setPayerId } from '../redux/fee-schedule/actions';

import { RootState } from '../redux/types';
import { connect } from 'react-redux';

export function mapStateToProps(state: RootState): StateProps {
  return {
    feeScheduleList: state.feeSchedule.feeScheduleList,
    selectedPayerId: state.feeSchedule.payerId || '',
    selectedBillingProviderId: state.feeSchedule.billingProviderId || -1,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators(
      {
        onPageDidMount,
        onPageWillUnmount,
        setPayerId,
        setBillingProviderId,
        setCptSearch,
        saveFeeSchedule,
      },
      dispatch
    ),
  };
}

export const FeeScheduleContainer = connect<StateProps, DispatchProps, any, RootState>(mapStateToProps, mapDispatchToProps)(FeeScheduleComponent);
